// Wrapper sopra `openapi-fetch` con i tipi generati da openapi.yaml.
//
// Uso:
//   import { api } from "@/api/client";
//   const { data, error } = await api.GET("/v1/markets", { params: { query: { limit: 20 } } });
//
// L'utente è autenticato via header `X-User-Id` (MVP, ADR sostituibile con JWT).
// Aggiungiamo l'header automaticamente quando lo store ha un userId attivo.

import createClient, { type Middleware } from "openapi-fetch";
import type { paths } from "./schema.gen";

// Risolto via Vite proxy in dev (vedi vite.config.ts) e via env in prod.
const BASE_URL = import.meta.env.VITE_API_BASE ?? "";

let _userId: string | null = null;

/** Imposta l'header `X-User-Id` per tutte le richieste successive. */
export function setApiUser(userId: string | null) {
  _userId = userId;
}

const authMiddleware: Middleware = {
  async onRequest({ request }) {
    if (_userId) request.headers.set("X-User-Id", _userId);
    return request;
  },
};

export const api = createClient<paths>({ baseUrl: BASE_URL });
api.use(authMiddleware);
